module.exports = __webpack_public_path__ + "static/media/Cross-bright-red.76474798.svg";